import React from 'react';
import Replies from '../replies';

const AdminReplies = () => <Replies adminMode />;

export default AdminReplies;
